import api from './api';
import { RuleTemplate, RuleApplication, InputSchema } from '../types/rule';

// 规则 API
export const ruleApi = {
  // 创建规则
  createRule: (data: {
    name: string;
    description?: string;
    workflowId: string;
    inputSchema: InputSchema;
  }) => api.post<RuleTemplate>('/rules', data),

  // 获取规则列表
  listRules: (status?: string) =>
    api.get<{ rules: RuleTemplate[]; total: number }>('/rules', { params: { status } }),

  // 获取规则详情
  getRule: (id: string) => api.get<RuleTemplate>(`/rules/${id}`),

  // 更新规则
  updateRule: (id: string, data: Partial<RuleTemplate>) =>
    api.put<RuleTemplate>(`/rules/${id}`, data),

  // 删除规则
  deleteRule: (id: string) => api.delete<void>(`/rules/${id}`),

  // 查找匹配的规则
  matchRules: (inputSchema: InputSchema, minScore?: number) =>
    api.post<{ rules: Array<RuleTemplate & { matchScore: number }>; total: number }>(
      '/rules/match',
      { inputSchema, minScore }
    ),

  // 应用规则
  applyRule: (ruleId: string, inputFileId: string) =>
    api.post<RuleApplication>(`/rules/${ruleId}/apply`, { inputFileId }),

  // 检测并应用规则
  detectAndApply: (inputFileId: string, autoApply?: boolean) =>
    api.post<{
      matched: boolean;
      rule?: RuleTemplate;
      matchScore?: number;
      application?: RuleApplication;
      message: string;
    }>('/rules/detect-and-apply', { inputFileId, autoApply }),

  // 获取应用记录
  getApplication: (applicationId: string) =>
    api.get<RuleApplication>(`/rules/applications/${applicationId}`),

  // 获取规则的应用记录列表
  listApplications: (ruleId: string) =>
    api.get<{ applications: RuleApplication[]; total: number }>(`/rules/${ruleId}/applications`),
};

export default ruleApi;
